import { inject } from '@angular/core';
import { type CanActivateFn, Router, type UrlTree } from '@angular/router';
import { AUTH_RETURN_URL_QUERY_PARAM, AuthService } from '@core/auth/auth.service';

/**
 * Allows route when authenticated. Otherwise redirects to sign-in with return URL.
 * Apply to shell layout or feature routes that require a session.
 */
export const authGuard: CanActivateFn = (_route, state): boolean | UrlTree => {
  const auth = inject(AuthService);
  const router = inject(Router);

  if (auth.isAuthenticated()) {
    return true;
  }

  return router.createUrlTree(['/auth', 'sign-in'], {
    queryParams: { [AUTH_RETURN_URL_QUERY_PARAM]: state.url },
  });
};
